import PrivateRouter from "./privateRouter";

export default PrivateRouter;
